var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("static/sound/rIcon.png")

  var m1 = require("static/specialty/repeat-group.png")

  var l0 = _vm.__map(_vm.payInfo.checkList, function(item, index) {
    var m2 = _vm.$getImg(item.coverImageUrl)
    return {
      $orig: _vm.__get_orig(item),
      m2: m2
    }
  })

  var m3 = parseFloat(_vm.price)

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      !_vm.submitLoading ? _vm.onSubmit() : ""
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        l0: l0,
        m3: m3
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }